import { GET_DRIVERS } from "../constants/ActionTypes"

const initialState = {
}

const drivers = (state = initialState, action) => {
  switch (action.type) {
    case GET_DRIVERS:
      return {
        ...state,
        ...action.drivers,
      }
    default:
      return state
  }
}

export default drivers